import React from 'react';
import styles from './styles.module.css';

export interface SkipBatteryProps{
    bars?: number
}

const SkipBattery: React.FC<SkipBatteryProps> = ({ bars = 0 })=>{

    // Elements
    const contentEl = React.useRef<HTMLDivElement>(null);

    // Helpers
    const isBatteryLow = ()=>{
        return bars === 1;
    }

    const isBatteryEmpty= ()=>{
        return bars < 1;
    }

    return(
        <div className={styles.skipBatteryContainer}>
            <div className={`${styles.skipBattery} ${isBatteryLow() ? styles.batteryYellow : ''} ${isBatteryEmpty() ? styles.batteryRed : ''}`}>
                {
                    (
                        ()=>{
                            let batteryBars = [];
                            for (let i = 0; i < bars; i++) {
                                batteryBars.push(
                                    <div className={`${styles.skipBatteryBar} ${isBatteryLow() ? styles.batteryYellow : ''} ${isBatteryEmpty() ? styles.batteryCapRed : ''}`}/>
                                );
                            }
                
                            return batteryBars;
                        }
                    )()
                }
            </div>
            <div className={`${styles.skipBatteryCap} ${isBatteryLow() ? styles.batteryCapYellow: ''} ${isBatteryEmpty() ? styles.batteryCapRed: ''}`}></div>
        </div>
    )
}

export default SkipBattery;